import MaterialTable, { Column } from "@material-table/core";
import {
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import Grade from "@mui/icons-material/Grade";
import { MatterService } from "../../../services/ClientService";
import { Globals } from "../../../helpers/globals";
import * as APIModels from "../../../models";
import { CloudUpload } from "@mui/icons-material";
import {
    flatten,
    FlattenedMatterTemplate,
    MatterMappingReduced,
    MatterReduced,
} from "../MatterManagmentTypes";
import { Link } from "react-router-dom";
import { AddCircle } from "@material-ui/icons";
import AppBar from "../AppBar";

const ArchivePage = () => {
    const renderFields = (obj: Array<MatterMappingReduced>) => {
        const sortedObj = obj.sort((a, b) => {
            return Object.keys(a)
                .join("")
                .localeCompare(Object.keys(b).join(""));
        });
        return (
            <TableBody>
                {sortedObj.map(({ id, key, value }) => (
                    <TableRow key={id}>
                        <TableCell>{key}</TableCell>
                        <TableCell>{value}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        );
    };
    const organizationId = Globals.currentUserValue.organizationID;
    const ArchivedTemplateColumns: Column<FlattenedMatterTemplate>[] = [
        { title: "Filename", field: "filename", editable: "never" },
        { title: "Uploader", field: "uploader", editable: "never" },
        { title: "Notes", field: "notes" },
    ];
    const ArchivedMatterColumns: Array<Column<MatterReduced>> = [
        {
            title: "Matter Number",
            field: "matterNumber",
            editable: "never",
            render: (obj) => (
                <span>
                    <b>{obj.matterNumber}</b>
                </span>
            ),
        },
        {
            title: "Identifier",
            field: "identifier",
            render: (obj) => (
                <span>
                    {obj.identifier.key}: {obj.identifier.value}
                </span>
            ),
            customFilterAndSearch(filter, rowData, _) {
                return filter === rowData.identifier.value;
            },
        },
        {
            title: "Fields",
            customFilterAndSearch(filter, rowData, _) {
                const jsonObject = rowData.mappings;
                return jsonObject.some((mapping) => {
                    const truthy = mapping.value
                        .toLowerCase()
                        .includes(String(filter).toLowerCase());
                    if (truthy) {
                        console.log({
                            truthy: { ...mapping },
                        });
                    }
                    return truthy;
                });
            },
            render: (obj) => (
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        setMatterNumberDisplaed(
                            obj.matterNumber ?? "0000000000"
                        );
                        setFieldsDisplayed(obj.mappings);
                        setShowFieldsModal(true);
                    }}
                >
                    Show
                </Button>
            ),
        },
    ];

    const reduce = (matter: APIModels.MatterResponse): MatterReduced => {
        const reducedMappings: Array<MatterMappingReduced> =
            matter.mappings?.map((mapping) => {
                return {
                    id: mapping.id ?? APIModels.EmptyGuid,
                    key: mapping.fieldKey ?? "",
                    value: mapping.fieldName ?? "",
                };
            }) ?? [];
        return {
            id: matter.id,
            matterNumber: matter.matterNumberV2,
            mappings: reducedMappings,
            identifier: {
                id: matter.identifier?.matterMapping?.id,
                key: matter.identifier?.matterMapping?.fieldKey,
                value: matter.identifier?.matterMapping?.fieldName,
            },
        } as MatterReduced;
    };

    const refreshMatterData = () => {
        MatterService.getAllV2({
            organizationId: organizationId ?? APIModels.EmptyGuid,
            active: false,
        }).then((res) => {
            if (res.data && res.successful) {
                const objs = res.data.map<MatterReduced>(reduce);
                setMatters(objs);
            } else {
                console.error(res.errorMessage);
            }
        });
    };

    const refreshTemplateData = () => {
        MatterService.getAllTemplates({
            organizationId: organizationId ?? APIModels.EmptyGuid,
            active: false,
        })
            .then((res) => {
                if (res.data && res.successful) {
                    setTemplates(
                        res.data?.map((template) => flatten(template))
                    );
                } else {
                    console.error({ 500: res.errorMessage });
                }
            })
            .catch((err) => {
                console.error({ Fatal: err });
            });
    };

    useEffect(() => {
        refreshMatterData();
        refreshTemplateData();
    }, [organizationId]);

    /* STATE  */
    const [matterNumberDisplaed, setMatterNumberDisplaed] =
        useState<string>("0000000000");
    const [fieldsDisplayed, setFieldsDisplayed] =
        useState<Array<MatterMappingReduced>>();
    const [showFieldsModal, setShowFieldsModal] = useState<boolean>(false);
    const [templates, setTemplates] = useState<Array<FlattenedMatterTemplate>>(
        [] as Array<FlattenedMatterTemplate>
    );
    const [matters, setMatters] = useState([] as Array<MatterReduced>);

    return (
        <div className="content">
            <div className="container-fluid">
                <Dialog
                    open={showFieldsModal}
                    onClose={() => {
                        setShowFieldsModal(false);
                        setFieldsDisplayed(undefined);
                    }}
                >
                    <DialogTitle>{matterNumberDisplaed}</DialogTitle>
                    <DialogContent>
                        <Table>
                            <TableHead>
                                <TableCell>Field</TableCell>
                                <TableCell>Value</TableCell>
                            </TableHead>
                            {fieldsDisplayed && renderFields(fieldsDisplayed)}
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <Stack direction="row-reverse">
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => setShowFieldsModal(false)}
                            >
                                <Stack direction="row" spacing={2}>
                                    <CloudUpload />
                                    <b></b>
                                </Stack>
                            </Button>
                        </Stack>
                    </DialogActions>
                </Dialog>
                <Stack direction="column" spacing={4} marginTop={4}>
                    <AppBar
                        sx={{ width: "100%", paddingY: 1, paddingX: 2 }}
                        buttonSpacing={6}
                        iconSpacing={6}
                    />

                    <MaterialTable
                        columns={ArchivedMatterColumns}
                        data={matters}
                        title="Achived Matters"
                        actions={[
                            {
                                icon: () => <AddCircle />,
                                tooltip: "Archive",
                                onClick: (event, rowData) => {
                                    const row = rowData as MatterReduced;
                                    MatterService.unarchive({
                                        matterId: row.id ?? APIModels.EmptyGuid,
                                    }).then(refreshMatterData);
                                },
                            },
                        ]}
                    />
                    <MaterialTable
                        columns={ArchivedTemplateColumns}
                        data={templates}
                        title="Archived Templates"
                        actions={[
                            {
                                icon: () => <Grade />,
                                tooltip: "Archive",
                                onClick: (event, rowData) => {
                                    const row =
                                        rowData as FlattenedMatterTemplate;
                                    MatterService.unarchiveTemplate({
                                        templateId: row.id,
                                    }).then(refreshTemplateData);
                                },
                            },
                        ]}
                    />
                </Stack>
            </div>
        </div>
    );
};

export default ArchivePage;
